export const responsiveSrcGenerator = (url: string, width: number, height: number): string =>
  `${url}?fm=webp&w=${Math.round(width / 2)}&h=${Math.round(height / 2)}`;
